<ng-container>
    <eol-setups-supplier>
    </eol-setups-supplier>
    <hr class="m-50">
    <eol-setups-fiberglass>
    </eol-setups-fiberglass>
</ng-container>